import Button from 'antd/lib/button'
import Cascader from 'antd/lib/cascader'
import Col from 'antd/lib/col'
import Checkbox from 'antd/lib/checkbox'
import Form from 'antd/lib/form'
import Icon from 'antd/lib/icon'
import Input from 'antd/lib/input'
import Radio from 'antd/lib/radio'
import Modal from 'antd/lib/modal'
import Row from 'antd/lib/row'
import Select from 'antd/lib/select'
import Spin from 'antd/lib/spin'
import Tooltip from 'antd/lib/tooltip'
import debounce from 'lodash.debounce'
import isEqual from 'lodash.isequal'
import React, { Component } from 'react'
import * as L from 'react-leaflet'
import { EditControl } from "react-leaflet-draw"
import { connect } from 'react-redux'
import { AvailableActions } from '../../redux/actions/dataQuery'
import utf8 from 'utf8'
import parseYears from '../../modules/parseYears.js'
import parseTimeIntervals from '../../modules/parseTimeIntervals.js'
import DateRangeInput from './DateRangeInput.jsx'
import GeoTree from './GeoTree'
import HelpPopovers from './HelpPopovers.jsx'
import SimpleMultiLocationSearch from './SimpleMultiLocationSearch.jsx'
import createParamaterForm from './createParameterForm.js'
import generateMetQL from './generateMetQL.js'

import s from './style.scss'
import CsvInput from './CsvInput.jsx'
import ReactHighcharts from 'react-highcharts/ReactHighstock'
import mbUrl from '../../modules/mbUrl'

class DataQueryForm extends Component {

    /** Years for "startdate + years" selection */
    years = [];

    /** Leaflet tile sources */
    tileLayers = [
        {
            key: 'mb',
            url: 'https://static.meteoblue.com/pub/tiles/terrain_political/{z}/{x}/{y}.png',
            attribution: 'Wikimedia maps + meteoblue relief |' +
                '<a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a>',
            minZoom: 3,
            maxZoom: 11
        }, {
            key: 'osm',
            url: 'https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png',
            minZoom: 12,
            maxZoom: 15
        }
    ]

    constructor(props) {
        super(props);
        this.state = {
            dataset: [],
            dateRanges: [['2011-11-11', '2012-12-12']],
            runOnJobQueue: false,
            jobId: undefined,
            queueModal: 'closed',
            isChecking: false,
            isLoading: false,
            isContentAreaOpen: false,
            lastError: false,
            highcharts: undefined,
            resultGeoMap: undefined,
            metQLQuery: undefined,
            metQLUrl: undefined,
            timeIntervalsListLineNumbers: [],
            timeIntervalsListErrors: '',
            timeIntervalsListLinesWithErrors: [],
            startDateYearsIsValid: true,
            server: mbUrl.getServer(),
            hasLoadingTransformationsError: false,
            loadingTransformationsErrorMsg: null,
            isLoadingTransformation: false,
        }

        // TODO: avoid monkey patching
        this.updateCascader = debounce(this.updateCascader, 800)
        this.check = debounce(this.check, 1200, {leading: true})
    }

    bug(val, hint) {
        if(typeof hint === 'undefined') {
            console.log(val)
        } else {
            console.log(hint, val);
        }
        return val;
    }

    componentDidUpdate(prevProps, prevState, snapshot) {

        // TODO: write redux store state to url
        //history.replaceState(null, null, '?dataquery=' + encodeURIComponent(JSON.stringify(nextProps.store)))

        // TODO: maybe this is a good place to update the metQL

        if(this.isDataSeriesVisible() && !isEqual(prevProps.store, this.props.store)) {
            this.updateCascader()
            this.check().catch(e => {console.log(e)})
        }

    }

    componentWillMount() {

        // TODO: hydrate store from url

        // let url = (new URL(window.location.href)).searchParams.get("dataquery");
        //
        // if(url) {
        //
        //     let state = JSON.parse(url)
        //
        //     // convert time ranges object to Map
        //     console.log('before', state)
        //     const map = new Map();
        //     Object.keys(state.dateRanges).forEach(key => {
        //         map.set(key, state.dateRanges[key]);
        //     });
        //     state.dateRanges = map
        //     console.log('after', state)
        //
        //
        //     this.props.setDataQuery({...state})
        // }

    }

    componentDidMount() {
        this.updateCascader()
        this.loadAvailableTransformation()
    }

    makeMetQL = options =>
        generateMetQL(
            options,
            this.props.store,
            this.props.form.getFieldValue('allDataSeries')
        )

    updateCascader() {

        this.setState({
            isDataSeriesListLoading: true,
            dataSeriesListLoadingError: false
        })

        // TODO: try to do this in a more react-redux way
        setTimeout( () => {

            const postBody = this.makeMetQL({ forListApi: true })

            const url = mbUrl.getSigned(
                '/dataset/list', false, { postBody, server: this.state.server }
            )

            fetch(url,
                {
                    method: 'POST',
                    mode: 'cors',
                    body: postBody,
                    headers: {
                        'content-type': 'application/json'
                    }
                }
            )
                .then((response) => {
                    if (!response.ok) {
                        throw Error(response.statusText);
                    }
                    return response;
                })
                .then((response) => response.json())
                .then((parsedResponse) => {
                    this.setState({
                        dataset: parsedResponse
                    })
                    this.setState({
                        isDataSeriesListLoading: false,
                        dataSeriesListLoadingError: false
                    })
                })
                .catch((error) => {
                    this.setState({
                        // TODO: find proper place for displaying this info
                        isDataSeriesListLoading: false,
                        dataSeriesListLoadingError: 'Could not load data series list.'
                    })
                });
        },300)
    }

    antCascaderSearchOptions = {
        'filter': (inputValue, option) => {
            let lcInputValue = inputValue.toLowerCase();
            for (let i = 0; i < option.length; i++) {
                if (option[i].label.toLowerCase().indexOf(lcInputValue) >= 0) {
                    return true;
                }
            }
            return false;
        },
        // TODO: maybe highlight keyword in search result (without affecting performance)
        'render': (inputValue, path) => {
            return path.reduce((acc, curr, i) => {
                return acc + curr.label + (i !== 4 ? ' / ' : '');
            }, '');
        }
    };

    handleCascaderChange = (value, options, fieldName) => {

        // add data series fields
        let allDataSeries = this.props.store.allDataSeries.slice()
        eval(fieldName).dataSeriesParams = []
        eval(fieldName + '.dataSeriesParams').push(...options[4].parameterGroups)
        this.setState({ allDataSeries })
    }

    loadAvailableTransformation = () => {

        this.setState({
            hasLoadingTransformationsError: false,
            loadingTransformationsErrorMsg: null,
            isLoadingTransformation: true,
        })

        setTimeout(() => {

            const locationSearchMode = this.props.form.getFieldValue('locationSelectionMode')
            let locationType = ''

            if(['locationSearch','coordinatesList','coordinatesDatesList'].includes(locationSearchMode)) {
                locationType = 'point'
            } else if(['customArea','area'].includes(locationSearchMode)) {
                locationType = 'polygon'
            } else {
                if(['MultiPoint'].includes(this.props.store.geoJsonParsed.geometry)) {
                    locationType = 'point'
                } else if (['GeonamePolygon', 'MultiGeonamePolygon', 'Polygon'].includes(this.props.store.geoJsonParsed.geometry)) {
                    locationType = 'polygon'
                }
            }

            const url = mbUrl.getSigned(
                '/dataset/transformations',
                'type=' + locationType,
                {server: this.state.server}
            )

            fetch(url,
                {
                    method: 'GET',
                    mode: 'cors',
                }
            )
            .then(response => response.json())
            .then((parsedResponse) => {

                if(parsedResponse.error === true) {
                    throw new Error('Could not load available transformations: ' +
                        parsedResponse.error_message)
                } else {
                    this.setState({
                        availableTransformations: parsedResponse,
                        isLoadingTransformation: false,
                        hasLoadingTransformationsError: false,
                        loadingTransformationsErrorMsg: null,
                    })
                }

            }).catch(e => {
                this.setState({
                    isLoadingTransformation: false,
                    hasLoadingTransformationsError: true,
                    loadingTransformationsErrorMsg: e.message,
                })
            })
        },500)
    }

    createDataSeriesForm = (desc, parentFieldName = 'allDataSeries',isDisabled) => {

        let form = [];

        desc.forEach((field,i) => {

            let isRecursive = field.parameters && 'dataQuery' in field.parameters

            if(field.type === 'dataset' || isRecursive) {

                let fieldName = ''

                if(field.type === 'dataset') {
                    fieldName = `${parentFieldName}[${i}]`
                } else if('dataQuery' in field.parameters) {
                    fieldName = `${parentFieldName}.transformations[${i}]`
                }

                form.push(
                    <Form.Item
                        key={i + 'casc'}
                        className={s.formItem}
                        validateStatus={this.state.isDataSeriesListLoading ? 'validating' : ''}
                    >
                        <div className={s.dataSeriesField}>
                            { !(field.type === 'dataset' && desc.length < 2) &&
                                <Icon
                                  type="minus-circle-o"
                                  className={s.removeIcon}
                                  onClick={(e) => this.removeTransformation(e, {
                                      fieldname: `${parentFieldName}.transformations[${i}]`,
                                      parentfieldname: parentFieldName,
                                      index: i,
                                  })}
                                />
                            }
                            <div className={s.cascaderInputWrapper}>
                                { isRecursive &&
                                    <span>
                                        { createParamaterForm(
                                            [field],
                                            `${parentFieldName}.transformations[${i}]`,
                                            'transformation',
                                            this.props.form,
                                            isDisabled
                                        )}
                                    </span>
                                }
                                { this.props.form.getFieldDecorator(fieldName + '.dataSeries',{
                                    onChange: (value, options) => this.handleCascaderChange(value, options, fieldName)
                                })(
                                    <Cascader
                                        key={i + 'casc'}
                                        options={this.state.dataset}
                                        popupClassName={s.dataSeriesPopup}
                                        placeholder={this.state.isDataSeriesListLoading
                                            ? 'Loading available data series...'
                                            : 'Select weather variable in list or start typing'
                                        }
                                        showSearch={this.antCascaderSearchOptions}
                                        allowClear={false}
                                        disabled={isDisabled}
                                    />
                                )}
                                { (this.state.isLoadingTransformation && !this.state.hasLoadingTransformationsError) &&
                                    <span>
                                        <Icon type="loading" /> {' '}
                                        Loading available transformations
                                    </span>
                                }
                                { this.state.hasLoadingTransformationsError &&
                                    <span>
                                        <Icon type="exclamation-circle-o" /> {' '}
                                        { this.state.loadingTransformationsErrorMsg + ' ' }
                                        <span className={s.linklike}
                                            onClick={(e) => {
                                                this.loadAvailableTransformation(fieldName)
                                            }}
                                        >Try again
                                        </span>
                                    </span>
                                }
                            </div>
                        </div>
                    </Form.Item>
                )

                form.push(
                    <div style={{marginLeft: '50px'}} key={i + 'div'}>

                        {/* Create data params field (i.e. GDD) */}
                        { 'dataSeriesParams' in field &&
                        createParamaterForm(
                            field.dataSeriesParams,
                            fieldName + '.dataSeriesParams',
                            'dataSeriesParam',
                            this.props.form,
                            isDisabled
                        ) }

                        {/* Create data series field */}
                        { 'transformations' in field &&
                        this.createDataSeriesForm(field.transformations, fieldName, isDisabled) }

                        {/* Dropdown for all available transformations */}
                        { (this.state.availableTransformations && !this.state.hasLoadingTransformationsError) &&
                            <React.Fragment>
                                <Tooltip mouseEnterDelay={0.3}
                                    title="Select a transformation from the drop-down menu to add it">
                                    <span key={i + 'icon'}>
                                        <Icon className={s.addIcon} type="plus-circle-o" />
                                    </span>
                                </Tooltip>
                                <Select
                                    key={i + 'avail'}
                                    style={{width: '25em', marginBottom: '1em'}}
                                    placeholder={'Add transformation'}
                                    onSelect={(e) => {
                                        this.addTransformation(e,fieldName)
                                    }}
                                    showSearch
                                    dropdownMatchSelectWidth={false}
                                    dropdownStyle={{width: '300px'}}
                                    disabled={isDisabled}
                                    value={'Add transformation'}
                                >
                                    { this.state.availableTransformations.map((transf, j) =>
                                        <Select.Option value={JSON.stringify(transf)} key={j}>
                                            {transf.label}
                                        </Select.Option>
                                    )}
                                </Select>
                            </React.Fragment>
                        }
                    </div>
                )

            } else if('parameters' in field) {

                // Create transformation field
                form.push(
                    <span key={i + 'icon'}>
                        <Icon
                            className={s.removeIcon}
                            type="minus-circle-o"
                            onClick={(e) => this.removeTransformation(e, {
                                fieldname: `${parentFieldName}.transformations[${i}]`,
                                parentfieldname: parentFieldName,
                                index: i,
                            })}
                        />
                    </span>
                )
                form.push(createParamaterForm(
                    [field],
                    `${parentFieldName}.transformations[${i}]`,
                    'dataSeriesParam',
                    this.props.form,
                    isDisabled
                ))

            } else {

                form.push(
                    <span key={i}>
                        <span>
                            <Icon
                                type="minus-circle-o"
                                className={s.removeIcon}
                                onClick={(e) => this.removeTransformation(e, {
                                    fieldname: `${parentFieldName}.transformations[${i}].${field.type}`,
                                    parentfieldname: parentFieldName,
                                    index: i,
                                })}
                            />
                            {field.label} { 'text' in field && field.text }

                            {this.props.form.getFieldDecorator(`${parentFieldName}.transformations[${i}].type`,{
                                initialValue: `${field.type}`
                            })(
                                <Input type={'hidden'} />
                            )}

                            <br />
                        </span>
                    </span>
                )

            }

            if (desc.length < i - 1) {
                form.push(<br />)
            }

        })

        return form;
    }

    addDataSeriesField = () => {
        let desc = this.props.store.allDataSeries.slice()
        desc.push({
            type: "dataset",
            dataSeriesParams: [],
            transformations: [],
            availableTransformations: []
        })
        this.props.setDataQuery({ allDataSeries: desc })
    }

    addTransformation = (fieldDesc, fieldName) => {
        let allDataSeries = this.props.store.allDataSeries.slice()
        let desc = JSON.parse(fieldDesc)
        desc.transformations = []
        /* eslint-disable */
        eval(fieldName + '.transformations').push(desc)
        /* eslint-enable */
        this.props.setDataQuery({ allDataSeries })
    }

    /**
     * Removes a transformation field.
     * Impletation is quit ugly at the moment, because:
     * - We get the "JS object path" as string and eval() it
     * - We must do both, delete the field from the form description and from the form values
     * - After the form was rerendered we have to set the form values with a timeout
     */
        // TODO: refacor: dry, find eval alternative, find setTimeout alternative
    removeTransformation = (e, options) => {

        /* eslint-disable */

        let values = this.props.form.getFieldsValue()

        // remove the transformation

        let that = this

        console.log('options', options)

        if(options.parentfieldname === 'allDataSeries') {

            let removeFrom = eval('that.props.store.' + options.parentfieldname)
            removeFrom.splice(options.index, 1)
            this.props.setDataQuery({[eval('that.props.store.' + options.parentfieldname)]: removeFrom})

            eval('values.' + options.parentfieldname).splice(options.index, 1)
            setTimeout(() => {
                this.props.form.setFieldsValue(values)
            },150)

        } else {
            console.log('parentfieldname', options.parentfieldname)
            let removeFrom = eval('that.props.store.' + options.parentfieldname).transformations
            removeFrom.splice(options.index, 1)
            this.props.setDataQuery({[eval('that.props.store.' + options.parentfieldname).transformations]: removeFrom})

            eval('values.' + options.parentfieldname).transformations.splice(options.index, 1)

            setTimeout(() => {
                this.props.form.setFieldsValue(values)
            },150)

        }
        /* eslint-enable */

    }

    isDataSeriesVisible = () => {

        let isLocationSelected = false
        let isTimeSelected = false

        if (this.props.store.locationSelectionMode === 'locationSearch'
            && this.props.store.locations.length > 0) {
            isLocationSelected = true
        }

        if (this.props.store.locationSelectionMode === 'coordinatesList'
            && this.props.store.coordsListParsed.length > 0
            && this.props.store.coordsListIsValid === true)
        {
            isLocationSelected = true
        }

        if (this.props.store.locationSelectionMode === 'coordinatesDatesList'
            && this.props.store.coordsDatesListParsed.length > 0
            && this.props.store.coordsDatesListIsValid === true)
        {
            isLocationSelected = true
        }

        if (this.props.store.locationSelectionMode === 'customArea'
        && this.props.store.customPolygon !== undefined) {
            isLocationSelected = true
        }

        if (this.props.store.locationSelectionMode === 'area'
            && this.props.store.geonameIds !== undefined) {
            isLocationSelected = true
        }

        if (this.props.store.locationSelectionMode === 'geoJson'
            && this.props.store.geoJson !== undefined
            && this.props.store.geoJson !== ''
            && this.props.store.geoJsonError === false) {
            isLocationSelected = true
        }

        if(this.props.store.timeSelectionMode === 'timeIntervals'
            && this.props.store.dateRanges.length > 0) {
                this.props.store.dateRanges.map(dateRange => {
                    if(dateRange.length > 0) isTimeSelected = true
                })
        }

        if(this.props.store.timeSelectionMode === 'timeIntervalsCsv'
            && this.props.store.timeIntervalsListParsed.length > 0
            && this.state.timeIntervalsListLinesWithErrors.length === 0) {
            isTimeSelected = true
        }

        if(this.props.store.timeSelectionMode === 'startdateYears'
            && this.props.store.startDateYears.length > 0) {
            isTimeSelected = true
        }

        return isLocationSelected && isTimeSelected
    }

    submitHandler = (format, jobId = undefined) => {

        if(this.props.store.outputFormat === 'download') {
            this.downloadHandler(this.props.store.downloadFormat)
            return
        }

        this.setState({
            isLoading: true,
            isContentAreaOpen: true,
            lastError: false,
            highcharts: undefined,
            resultGeoMap: undefined,
        })

        if(format === 'metQLQuery') {
            this.setState({
                isLoading: false,
                metQLQuery: this.makeMetQL({ prettyPrint: true }),
                metQLUrl: mbUrl.getServer() + '/dataset/query?apikey=123456789&json=' + this.makeMetQL({ asUrlQuery: true })
            })
            this.props.setDataQuery({
                shareString: undefined            
            })
    
            return
        }

        const postBody = this.makeMetQL({format})

        let url = jobId
            ? 'https://queueresults.meteoblue.com/' + jobId
            : mbUrl.getSigned('/dataset/query', false, { postBody, server: this.state.server})

        let fetchOptions = jobId
            ? { method: 'GET' }
            : {
                method: 'POST',
                mode: 'cors',
                body: postBody,
                headers: {
                    'content-type': 'application/json'
                }
            }

        fetch(url, fetchOptions)
            .then(response => response.json())
            .then((parsedResponse) => {
                if('error_message' in parsedResponse
                    && parsedResponse.error_message === "This job must be executed on a job-queue")
                {
                    let request = mbUrl.getSigned(
                        '/dataset/query',
                        'json=' + this.makeMetQL({asUrlQuery: true, format, runOnJobQueue: true}),
                        { server: this.state.server }
                    )

                    if(url.length > 2000) {

                        const postBody = this.makeMetQL({format, runOnJobQueue: true, jobQueueRedirect: false})

                        request = [
                            mbUrl.getSigned('/dataset/query', false, { postBody, server: this.state.server }),
                            {
                                method: 'POST',
                                mode: 'cors',
                                body: postBody,
                                headers: {
                                    'content-type': 'application/json'
                                }
                            }
                        ]
                    }

                    this.handleQueuedJobs(request, 10, format)

                    setTimeout(() => {
                        this.props.setDataQuery({
                            shareString: undefined,
                        })
                        this.setState({
                            lastError: undefined,
                            highcharts: undefined,
                            resultGeoMap: undefined,
                            metQLQuery: undefined,
                            metQLUrl: undefined,
                        })
                    }, 300)

                } else if('error_message' in parsedResponse) {
                    this.setError(parsedResponse.error_message)
                } else {
                    this.setResult(parsedResponse, format)
                }
            })
            .catch(e => {
                this.setError('An unexpected error occured. ' +
                'Please try again or report to meteoblue. Error: ' + e)
            })

    }

    downloadHandler = (downloadFormat = 'csv') => {

        this.setState({downloadFormat})

        let metQL = this.makeMetQL({asUrlQuery: true, format: downloadFormat})
        let downloadUrl = mbUrl.getSigned('/dataset/query', 'json=' + metQL, { server: this.state.server })

        this.check()
            .then(() => {
                if(this.state.requiresJobQueue || metQL.length > 2000) {
                    this.setState({queueModal: 'prompt'})
                } else {
                    this.setState({ downloadUrl })
                }
            })
            .catch((e) => {
                console.error(e)
                this.setState({checkApiError: e.message})
            })
    }

    queuedDownloadHandler = () => {

        let request = mbUrl.getSigned(
            '/dataset/query',
            'json=' + this.makeMetQL({
                asUrlQuery: true,
                format: this.state.downloadFormat,
                runOnJobQueue: true,
                jobQueueRedirect: false}),
            { server: this.state.server }
        )

        if(request.length > 2000) {

            const postBody = this.makeMetQL({format: this.state.downloadFormat, runOnJobQueue: true})

            request = [
                mbUrl.getSigned('/dataset/query', false, { postBody, server: this.state.server }),
                {
                    method: 'POST',
                    mode: 'cors',
                    body: postBody,
                    headers: {
                        'content-type': 'application/json'
                    }
                }
            ]

        }

        this.handleQueuedJobs(request, 10, this.state.downloadFormat)
    }

    handleQueuedJobs = (url, failsCountdown = 10, format, jobId = undefined) => {

        if(!Array.isArray(url)) {
            url = [url]
        }

        fetch(...url)
            .then(response => response.json())
            .then(parsedResponse => {

                // If we get a proper error response, we do not try again. Retries are only required for network errors.
                if(parsedResponse.error) {
                    failsCountdown = 0
                }

                jobId = jobId || parsedResponse.id

                if(parsedResponse.status === 'waiting' || parsedResponse.status === 'running') {

                    this.setState({
                        queueProgress: parsedResponse.percentCompleted,
                        queueModal: parsedResponse.status,
                        jobId
                    })

                    setTimeout(() => {

                        const statusUrl = mbUrl.getSigned(
                            '/queue/status/' + jobId, false, {server: this.state.server}
                        )

                        this.handleQueuedJobs(statusUrl, failsCountdown, format, jobId)
                    },2000)

                } else if(parsedResponse.status === 'finished') {

                    this.setState({queueProgress: false})

                    let downloadFormats = [
                        'csv',
                        'json',
                        'kml',
                        'xlsx',
                        'csvTimeOriented',
                        'csvIrregular',
                        'xlsxTimeOriented',
                        'xlsxIrregular',
                        'netCDF'
                    ]

                    if(downloadFormats.includes(format)) {
                        let url = 'https://queueresults.meteoblue.com/' + jobId
                        this.setState({
                            queueModal: 'done',
                            queueDownloadResultUrl: url
                        })
                    } else {
                        this.setState({ queueModal: 'closed' })
                        this.submitHandler(format, jobId)
                    }

                } else if (parsedResponse.status === 'deleted') {
                    this.setState({queueProgress: false})
                    return
                } else if (parsedResponse.status === 'error') {
                    throw new Error(parsedResponse.error_message)
                }
            })
            .catch(e => {
                failsCountdown--
                if(failsCountdown > 0) {
                    this.handleQueuedJobs(
                        mbUrl.getSigned('/queue/status/' + jobId, false, {server: this.state.server}),
                        failsCountdown,
                        format,
                        jobId
                    )
                } else {
                    this.setState({
                        queueModal: 'failed',
                        queueModalErrorMsg: e.message,
                    })
                    this.setError(this.state.queueModal ? undefined : e.message)
                }
            })
    }

    deleteQueuedJob = (jobId) => {
        if (jobId === undefined) {
            console.error('Could not delete queued job. JobId is missing.')
            return
        }

        const url = mbUrl.getSigned('/queue/delete/' + jobId, false, {server: this.state.server})

        fetch(url, { method: 'DELETE' })
            .then(response => {
                if (!response.ok) {
                    throw new Error('Deleting Job failed.')
                } else {
                    this.setState({
                        queueModal: 'deleted',
                        isLoading: false
                    })
                }
            })
            .catch(error => {
                this.setState({
                    queueModal: 'delete failed',
                    queueModalErrorMsg: error,
                    isLoading: false
                })
            })
    }

    setError = errorMessage => {

        this.setState({isLoading: false})

        // timeout to give css some time to perform the fade out before fading in again
        setTimeout(() => {
            this.props.setDataQuery({
                shareString: undefined
            })
            
            this.setState({
                lastError: errorMessage,
                highcharts: undefined,
                resultGeoMap: undefined,
                metQLQuery: undefined,
                metQLUrl: undefined,
            })

            if(['running', 'prompt'].includes(this.state.queueModal)
                && !['geoJson','highcharts'].includes(this.state.downloadFormat))
            {
                this.setState({queueModal: 'failed'})
            }

        }, 300)
    }

    setResult = (parsedResponse, format) => {

        this.props.setDataQuery({
            shareString: undefined
        })
        
        this.setState({
            isLoading: false,
            lastError: undefined,
            highcharts: format === 'highcharts' ? parsedResponse : undefined,
            resultGeoMap: format === 'geoJson' ? parsedResponse : undefined,
            metQLQuery: undefined,
            metQLUrl: undefined,
        })

        if(format === 'geoJson') {
            setTimeout(() => {
                this.resultMap.leafletElement.fitBounds(
                    this.resultGroup.leafletElement.getBounds()
                )
            }, 600)
        }
    }

    // TODO: maybe use this to update available transformations
    check = () => {

        this.setState({isChecking: true})

        return new Promise((resolve, reject) => {

            const postBody = this.makeMetQL({ checkOnly: true })

            const url = mbUrl.getSigned(
                '/dataset/query', false, { postBody, server: this.state.server}
            )

            fetch(url,
                {
                    method: 'POST',
                    mode: 'cors',
                    body: postBody,
                    headers: {
                        'content-type': 'application/json'
                    }
                }
            )
                .then(response => response.json())
                .then((parsedResponse) => {
                    if (parsedResponse.error) {
                        this.setState({
                            validationError: parsedResponse.error_message,
                            requiresJobQueue: false
                        })
                        reject(new Error('API returned error: ' + parsedResponse.error_message))
                        this.setState({isChecking: false})
                    } else {
                        this.setState({
                            validationError: false,
                            requiresJobQueue: parsedResponse.requiresJobQueue,
                            dataPoints: parsedResponse.datapoints
                        })
                        resolve()
                        this.setState({isChecking: false})
                    }
                }).catch(e => {
                    // TODO: handle network errors
                    reject(new Error('Network error: ' + e.message))
                    this.setState({isChecking: false})
                })

        })

    }

    isButtonDisabled = () => {
        return this.state.isLoading
            // || !this.isDataSeriesVisible()
            || this.state.isChecking
    }

    generateShareString = () => {
        let values = this.props.form.getFieldsValue()
        delete values.shareString // we don't need to restore the share string itself

        values.dateRanges = this.props.store.dateRanges
        values.allDataSeriesFields = this.props.store.allDataSeries
        values.geonameIds = this.props.store.geonameIds

        this.props.form.setFieldsValue({
            shareString: btoa(utf8.encode(JSON.stringify(values)))
        })
    }

    restoreFromShareString = () => {
        let shareString = JSON.parse(utf8.decode(atob(this.props.form.getFieldValue('shareString'))))

        // set store
        this.props.setDataQuery({
            allDataSeries: shareString.allDataSeriesFields,
            dateRanges: shareString.dateRanges
        })

        // set the selection modes, so the form fields are mounted to set their value
        setTimeout(() => {
            this.props.form.setFieldsValue({
                locationSelectionMode: shareString.locationSelectionMode,
                timeSelectionMode: shareString.timeSelectionMode
            })
        }, 400)
        
        // set values
        setTimeout(() => {
            delete shareString.allDataSeriesFields
            delete shareString.dateRanges
            delete shareString.locationSelectionMode
            delete shareString.timeSelectionMode
            this.props.form.setFieldsValue(shareString)
            
            // @todo: dirty fix to make sure csv validation is executed
            this.props.setDataQuery({
                coordsList: shareString.coordsList,
                coordsDatesList: shareString.coordsDatesList
            })

        }, 800)

        // set political area polygon
        setTimeout(() => {
            this.props.setDataQuery({
                geonameIds: shareString.geonameIds
            })
        },2000)
                                
    }
    // heading is set outside of react <h1 className={s.pageHeading}>Advanced access</h1>
    render() { return (
        <Form /* don't put onChange handler here! */ className={s.form}>
            <Row gutter={8}>
                <Col span={4}>
                    <span className={s.label}>Units</span>
                </Col>
                <Col span={20}>

                    <Form.Item className={s.unitSelect}>
                        Temperature
                        {this.props.form.getFieldDecorator('temperatureUnit', {
                            initialValue: this.props.store.temperatureUnit,
                            onChange: () => { this.updateCascader() }
                        })(
                            <Select>
                                <Select.Option value="C">°C</Select.Option>
                                <Select.Option value="K">K</Select.Option>
                                <Select.Option value="F">°F</Select.Option>
                            </Select>
                        )}
                    </Form.Item>

                    <Form.Item className={s.unitSelect}>
                        Windspeed
                        {this.props.form.getFieldDecorator('windspeedUnit', {
                            initialValue: this.props.store.windspeedUnit,
                            onChange: () => { this.updateCascader() }
                        })(
                            <Select>
                                <Select.Option value="m/s">m/s</Select.Option>
                                <Select.Option value="km/h">km/h</Select.Option>
                                <Select.Option value="mph">mph</Select.Option>
                                <Select.Option value="kn">kn</Select.Option>
                                <Select.Option value="bft">bft</Select.Option>
                            </Select>
                        )}
                    </Form.Item>

                    <Form.Item className={s.unitSelect}>
                        Length
                        {this.props.form.getFieldDecorator('lengthUnit', {
                            initialValue: this.props.store.lengthUnit,
                            onChange: () => { this.updateCascader() }
                        })(
                            <Select>
                                <Select.Option value="metric">metric</Select.Option>
                                <Select.Option value="imperial">imperial</Select.Option>
                            </Select>
                        )}
                    </Form.Item>

                    <Form.Item className={s.unitSelect}>
                        Energy
                        {this.props.form.getFieldDecorator('energyUnit', {
                            initialValue: this.props.store.energyUnit,
                            onChange: () => { this.updateCascader() }
                        })(
                            <Select>
                                <Select.Option value="watts">Watts</Select.Option>
                                <Select.Option value="joules">Joules</Select.Option>
                            </Select>
                        )}
                    </Form.Item>

                    { mbUrl.getServer() !== 'https://my.meteoblue.com' &&
                        <Form.Item className={s.unitSelect}>
                            <span>Server</span>
                            {this.props.form.getFieldDecorator('server', {
                                initialValue: 'staging',
                                onChange: val => { 
                                    switch(val) {
                                        case 'localhostHttps':
                                            this.setState({ server: 'https://localhost:8090' })
                                            break;
                                        case 'staging':
                                            this.setState({ server: 'https://mystaging.meteoblue.com' })
                                            break;
                                        case 'www':
                                            this.setState({ server: 'https://my.meteoblue.com' })
                                            break;
                                    }
                                }
                            })(
                                <Select dropdownMatchSelectWidth={false}>
                                    <Select.Option value="localhostHttps">
                                        https://localhost:8090
                                    </Select.Option>
                                    <Select.Option value="staging">Staging</Select.Option>
                                    <Select.Option value="www">Production</Select.Option>
                                </Select>
                            )}
                        </Form.Item>
                    }
                    

                </Col>
            </Row>

            <Row gutter={8}>
                <Col span={4}>
                    <span className={s.label}>Location selection mode</span>
                </Col>
                <Col span={20}>

                    <Form.Item>
                        {this.props.form.getFieldDecorator('locationSelectionMode', {
                            initialValue: this.props.store.locationSelectionMode,
                            onChange: () => {this.loadAvailableTransformation()},
                        })(
                            <Radio.Group >
                                <Radio.Button value="locationSearch">Location search</Radio.Button>
                                <Radio.Button value="coordinatesList">Coordinates list</Radio.Button>
                                <Radio.Button value="coordinatesDatesList">Coordinates and time</Radio.Button>
                                <Radio.Button value="customArea">Draw polygon</Radio.Button>
                                <Radio.Button value="area">Political area</Radio.Button>
                                <Radio.Button value="geoJson">JSON</Radio.Button>
                            </Radio.Group>
                        )}
                    </Form.Item>

                </Col>
            </Row>

            {this.props.store.locationSelectionMode === 'locationSearch' &&

                <Row gutter={8}>

                    <Col span={4}>
                        <span className={s.label}>Locations</span>
                    </Col>

                    <Col span={20}>
                        <SimpleMultiLocationSearch
                            antForm={this.props.form}
                            defaultValue={this.props.store.locations}
                        />
                    </Col>

                </Row>
            }

            {this.props.store.locationSelectionMode === 'coordinatesList' &&
                <Row gutter={8}>
                    <Col span={4}>
                        <span className={s.label}>
                            Coordinates <HelpPopovers.CoordinatesList />
                        </span>
                    </Col>
                    <Col span={20}>
                        <CsvInput
                            form={this.props.form}
                            onIsValid={this.updateCascader.bind(this)}
                            name={'coordsList'}
                            parseTimeIntervals={false}
                            placeholder={'47.56, 7.57, 279, "Basel"'}
                        />
                    </Col>
                </Row>
            }

            {this.props.store.locationSelectionMode === 'coordinatesDatesList' &&
                <Row gutter={8} className={s.row}>
                    <Col span={4}>
                        <span className={s.label}>
                            Coordinates and<br />time intervals<HelpPopovers.CoordinatesList />
                        </span>
                    </Col>
                    <Col span={20}>
                        <CsvInput
                            form={this.props.form}
                            onIsValid={this.updateCascader.bind(this)}
                            name={'coordsDatesList'}
                            parseTimeIntervals={true}
                            placeholder={'47.56, 7.57, 279, "Basel", 2015-05-05, 2016-06-06'}
                        />
                    </Col>
                </Row>
            }

            {this.props.store.locationSelectionMode === 'customArea' &&

                <Row gutter={8}>

                    <Col span={4}>
                        <span className={s.label}>Draw polygon
                            <HelpPopovers.DrawPolygon />
                        </span>
                    </Col>

                    <Col span={20}>
                        {/* Warning: Min and max map zoom must be set. Otherwise map will crash on component unmount.
                            No idea why. */}
                        <L.Map style={{height: '400px'}} center={[47,7]} zoom={7} minZoom={3} maxZoom={15}>

                            { this.tileLayers.map(layer => <L.TileLayer {...layer} />) }

                            <L.FeatureGroup>
                                <EditControl
                                    ref="edit"
                                    position='topright'
                                    onDrawStart={(e) => {
                                        let layerContainer = this.refs.edit.leafletElement.options.edit.featureGroup,
                                            layers = layerContainer._layers,
                                            layer_ids = Object.keys(layers),
                                            layer
                                        layer_ids.forEach(id => {
                                            layer = layers[id]
                                            layerContainer.removeLayer(layer)
                                        })
                                    }}
                                    onEdited={(e) => {
                                        let editedLayer = e.layers.getLayers()[0]
                                        if (editedLayer === undefined) {
                                            return // layer is undefined when user hits 'save' without any changes
                                        }
                                        let polygon = e.layers.getLayers()[0].toGeoJSON()
                                        this.props.setDataQuery({ customPolygon: polygon })
                                    }}
                                    onCreated={ (e) => {
                                        let polygon = e.layer.toGeoJSON()
                                        this.props.setDataQuery({ customPolygon: polygon })
                                    }}
                                    onDeleted={this._onDeleted}
                                    draw={{
                                        polyline: false,
                                        circle: false,
                                        marker: false,
                                        circlemarker: false,
                                        polygon: {
                                            allowIntersection: false,
                                            drawError: {
                                                color: '#e12400',
                                                message: 'Polygon intersects'
                                            },
                                        },
                                    }}
                                    edit={{
                                        remove: false
                                    }}
                                />
                            </L.FeatureGroup>
                        </L.Map>
                    </Col>

                </Row>
            }

            {this.props.store.locationSelectionMode === 'area' &&

                <Row gutter={8} className={s.row}>

                    <Col span={4}>Political area</Col>

                    <Col span={20}>
                        <GeoTree layers={this.tileLayers} />
                    </Col>

                </Row>
            }

            {this.props.store.locationSelectionMode === 'geoJson' &&

                <Row gutter={8}>

                    <Col span={4}>JSON</Col>

                    <Col span={20}>
                        {this.props.form.getFieldDecorator('geoJson')(
                            <Input.TextArea
                                autosize={{ minRows: 5 }}
                                placeholder={"Insert a GeoJSON geometry object."}
                                onChange={e => {
                                    try {
                                        this.props.setDataQuery({geoJsonError: false})
                                        let json = e.target.value.trim()

                                        // add outer curly brackets if missing to have vaild json
                                        if(json[0] !== '{') json = '{' + json + '}'

                                        let parsed = JSON.parse(json)
                                        if(typeof parsed.geometry === 'undefined') {
                                            this.props.setDataQuery({geoJsonError: 'Missing key "geometry"'})
                                        }
                                        this.props.setDataQuery({geoJsonParsed: parsed})
                                    } catch (err) {
                                        this.props.setDataQuery({
                                            geoJsonError: 'Invalid JSON: ' + err
                                        })
                                    }
                                }}
                            />
                        )}
                        { this.props.store.geoJsonError &&
                            <div>{this.props.store.geoJsonError}</div>
                        }
                    </Col>

                </Row>
            }

            { (this.props.store.locationSelectionMode === 'customArea'
                || this.props.store.locationSelectionMode === 'geoJson'
                ) &&

                <Row gutter={8} className={s.row}>
                    <Col span={4}></Col>
                    <Col span={20}>
                        <Form.Item>
                            {this.props.form.getFieldDecorator('excludeSeaPoints', {
                                initialValue: this.props.store.excludeSeaPoints
                            })(
                                <Checkbox>Exclude sea points</Checkbox>
                            )}
                        </Form.Item>
                    </Col>
                </Row>
            }

            { (this.props.store.locationSelectionMode === 'locationSearch'
                || this.props.store.locationSelectionMode === 'coordinatesList'
                ) &&

                <Row gutter={8} className={s.row}>
                    <Col span={4}></Col>
                    <Col span={20}>
                        <Form.Item>
                            {this.props.form.getFieldDecorator('includeNeighbours', {
                                initialValue: this.props.store.includeNeighbours
                            })(
                                <Checkbox>Include neighbour grid-cells</Checkbox>
                            )}
                        </Form.Item>
                    </Col>
                </Row>
            }

            { this.props.store.locationSelectionMode !== 'coordinatesDatesList' &&
                <Row gutter={8}>
                    <Col span={4}>
                        <span className={s.label}>Time selection mode</span>
                    </Col>
                    <Col span={20}>

                        <Form.Item>
                            {this.props.form.getFieldDecorator('timeSelectionMode', {
                                initialValue: this.props.store.timeSelectionMode
                            })(
                                <Radio.Group>
                                    <Radio.Button value="timeIntervals">Time intervals</Radio.Button>
                                    <Radio.Button value="timeIntervalsCsv">Time intervals list</Radio.Button>
                                    <Radio.Button value="startdateYears">Start date + years</Radio.Button>
                                </Radio.Group>
                            )}
                        </Form.Item>

                    </Col>
                </Row>
            }

            { (this.props.store.timeSelectionMode === 'timeIntervals'
                && this.props.store.locationSelectionMode !== 'coordinatesDatesList') &&
                <Row gutter={8} className={s.row}>
                    <Col span={4}>
                        <span className={s.label}>Time intervals</span>
                    </Col>
                    <Col span={20}>
                        <DateRangeInput antForm={this.props.form}/>
                    </Col>
                </Row>
            }

            { (this.props.store.timeSelectionMode === 'timeIntervalsCsv'
                && this.props.store.locationSelectionMode !== 'coordinatesDatesList') &&

                <Row gutter={8} className={s.row}>
                    <Col span={4}>
                        <span className={s.label}>Time intervals list {' '}
                            <HelpPopovers.TimeIntervalsList />
                        </span>
                    </Col>
                    <Col span={20}>
                        <div className={s.coordinatsList}>

                            {this.props.form.getFieldDecorator('timeIntervalsListLineNumbers', {
                                initialValue: this.state.timeIntervalsListLineNumbers
                            })(
                                <Input.TextArea className={s.lineNumbers} autosize={{ minRows: 5 }} readOnly />
                            )}

                            {this.props.form.getFieldDecorator('timeIntervalsList', {
                                initialValue: this.props.store.timeIntervalsList,
                                onChange: (e) => {
                                    let parsed = parseTimeIntervals(e.target.value)
                                    this.props.setDataQuery({
                                        timeIntervalsListParsed: parsed.values
                                    })
                                    this.setState({
                                        timeIntervalsListLineNumbers: parsed.lineNumbers.join('\n'),
                                        timeIntervalsListErrors: parsed.status.join('\n'),
                                        timeIntervalsListLinesWithErrors: parsed.linesWithErrors,
                                    })
                                    if(parsed.linesWithErrors.length === 0) {
                                        this.updateCascader()
                                    }
                                }

                            })(
                                <Input.TextArea
                                    className={s.coordsListInput}
                                    autosize={{ minRows: 5 }}
                                    placeholder={"2011-02-15/2015-06-25"}
                                />
                            )}

                            {this.props.form.getFieldDecorator('timeIntervalsListErrors', {
                                initialValue: this.state.timeIntervalsListErrors
                            })(
                                <Input.TextArea autosize={{ minRows: 5 }} readOnly className={s.coordsListErrors} />
                            )}

                        </div>

                        {this.state.timeIntervalsListLinesWithErrors.length > 0 &&
                            <p className={s.coordsListErrorMsg}>
                                These lines have errors: {' '}
                                {this.state.timeIntervalsListLinesWithErrors.join(', ')}
                            </p>
                        }

                    </Col>
                </Row>
            }

            { (this.props.store.timeSelectionMode === 'startdateYears'
                && this.props.store.locationSelectionMode !== 'coordinatesDatesList') &&

                <Row gutter={8}>
                    <Col span={4}>
                        <span className={s.label}>Start date + years</span>
                    </Col>
                    <Col span={20} className={s.startDateWrapper}>

                        <div className={s.startDateFirstLine}>
                            {this.props.form.getFieldDecorator('startDateMonth', {
                                initialValue: this.props.store.startDateMonth,
                                onChange: this.updateCascader.bind(this)
                            })(
                                <Select
                                    showSearch
                                    placeholder="Select month"
                                >
                                    {["January", "February", "March", "April", "May", "June", "July", "August",
                                        "September", "October", "November", "December"]
                                        .map((month, i) => <Select.Option key={i + 1}>{month}</Select.Option>)}
                                </Select>
                            )}

                            {this.props.form.getFieldDecorator('startDateDay', {
                                initialValue: this.props.store.startDateDay,
                                onChange: this.updateCascader.bind(this)
                            })(
                                // TODO: add some kind of label
                                <Select
                                    showSearch
                                    placeholder="Select day"
                                >
                                    {[...Array(31).keys()].map((day) =>
                                        <Select.Option value={(day+1).toString()} key={day+1}>{day+1}</Select.Option>)}
                                </Select>
                            )}

                            <div />

                            {this.props.form.getFieldDecorator('startDateNumDays', {
                                initialValue: this.props.store.startDateNumDays,
                                onChange: this.updateCascader.bind(this)
                            })(
                                <Input
                                    addonBefore="Number of days"
                                    placeholder="e.g. 180"
                                    style={{minWidth: '200px'}}
                                />
                            )}
                        </div>

                        <Form.Item
                            extra={
                                <span style={{marginLeft: '0.25em'}}>
                                    <HelpPopovers.YearsExample />
                                    <span> | </span>
                                    {this.state.startDateYearsIsValid
                                        ? <span>
                                            {this.props.store.startDateYearsValues.length} {' '}
                                            years selected
                                        </span>
                                        : <span>Format error</span>
                                    }
                                </span>
                            }
                            hasFeedback
                            validateStatus={
                                this.state.startDateYearsIsValid ? 'success' : 'error'
                            }
                        >
                            {this.props.form.getFieldDecorator('startDateYears', {
                                initialValue: this.props.store.startDateYears,
                                onChange: e => {
                                    this.updateCascader

                                    let years = parseYears(e.target.value)

                                    this.props.setDataQuery({startDateYearsValues: years.values})
                                    this.setState({startDateYearsIsValid: years.valid})
                                }
                            })(
                                <Input
                                    mode="multiple"
                                    placeholder="Select year(s)"
                                />
                            )}

                        </Form.Item>

                    </Col>
                </Row>
            }

            {/* the "checkbox" approach for combining locations and time intervals.
                maybe we need it later */}
            {/* <Row gutter={8}>
                <Col span={4}></Col>
                <Col span={20}>
                    <Form.Item>
                        {this.props.form.getFieldDecorator('combineLocationsAndTimes', {
                            initialValue: this.props.store.combineLocationsAndTimes
                        })(
                            <Checkbox disabled={
                                !( this.props.store.locationSelectionMode === 'locationSearch'
                                || this.props.store.locationSelectionMode === 'coordinatesList')
                            }>
                                Combine locations and time intervals.
                            </Checkbox>
                        )}
                        <HelpPopovers.CombineLocationsAndTime />
                    </Form.Item>
                </Col>
            </Row> */}

            <Row gutter={8}>
                <Col span={4}>UTC offset</Col>
                <Col span={20}>
                    <Form.Item>
                        {this.props.form.getFieldDecorator('utcOffset', {
                            initialValue: this.props.store.utcOffset,
                        })(
                            <Select showSearch style={{ width: 100 }}>
                                {['-12:00', '-11:00', '-10:00', '-09:30', '-09:00', '-08:00', '-07:00', '-06:00',
                                    '-05:00', '-04:00', '-03:30', '-03:00', '-02:00', '-01:00', '+00:00', '+01:00',
                                    '+02:00', '+03:00', '+03:30', '+04:00', '+04:30', '+05:00', '+05:30', '+05:45',
                                    '+06:00', '+06:30', '+07:00', '+08:00', '+08:30', '+08:45', '+09:00', '+09:30',
                                    '+10:00', '+10:30', '+11:00', '+12:00', '+12:45', '+13:00', '+14:00']
                                    .reverse().map(offset =>
                                        <Select.Option key={offset} value={offset}>{offset}</Select.Option>
                                    )}
                            </Select>
                        )}
                    </Form.Item>
                </Col>
            </Row>

            <Row gutter={8} className={s.row}>
                <Col span={4}>
                    <span className={s.label}>Data series</span>
                    <HelpPopovers.DataSeries />
                </Col>
                <Col span={20}>

                {!this.isDataSeriesVisible() &&
                    <p className={s.error}>
                        Select at least one location and time range before adding data series.
                    </p>
                }

                {this.createDataSeriesForm(
                    this.props.store.allDataSeries,
                    'allDataSeries',
                    !this.isDataSeriesVisible()
                )}

                <Button
                    className={s.addButton}
                    icon="plus-circle-o"
                    onClick={this.addDataSeriesField}
                    disabled={!this.isDataSeriesVisible()}
                >
                    Add data series
                </Button>

                </Col>
            </Row>

            <Row gutter={8}>
                <Col span={4}>
                    <span className={s.label}>Fill gaps with</span> {' '}
                    {/* TODO: help */}
                </Col>
                <Col span={20}>

                    <Form.Item>
                        {this.props.form.getFieldDecorator('fillGapsWith', {
                            initialValue: this.props.store.fillGapsWith,
                        })(
                            <Radio.Group>
                                <Radio.Button value="none">None</Radio.Button>
                                <Radio.Button value="NEMSGLOBAL">NEMS GLOBAL</Radio.Button>
                                <Radio.Button value="ERA5">ERA5</Radio.Button>
                                <Radio.Button value="ARC2">ARC2</Radio.Button>
                                <Radio.Button value="CHIRPS2">CHIRPS2</Radio.Button>
                                <Radio.Button value="CMORPH">CMORPH</Radio.Button>
                            </Radio.Group>
                        )}
                    </Form.Item>

                </Col>
            </Row>

            <Row gutter={8}>
                <Col span={4}>
                    <span className={s.label}>Output format</span>
                </Col>
                <Col span={20}>

                    <Form.Item>
                        {this.props.form.getFieldDecorator('outputFormat', {
                            initialValue: this.props.store.outputFormat
                        }) (
                            <Radio.Group>
                                <Radio.Button value="highcharts">Chart</Radio.Button>
                                <Radio.Button value="geoJson">Map</Radio.Button>
                                <Radio.Button value="metQLQuery">API query</Radio.Button>
                                <Radio.Button value="download">Download</Radio.Button>
                            </Radio.Group>
                        )}
                    </Form.Item>

                </Col>
            </Row>

            { this.props.store.outputFormat === 'highcharts' &&
                <Row gutter={8}>
                    <Col span={4}>
                        <span className={s.label}>
                            Align intervals in chart
                            <HelpPopovers.AlignIntervalsInChart />
                        </span>
                    </Col>
                    <Col span={20}>

                        <Form.Item>
                            {this.props.form.getFieldDecorator('timeIntervalsAlignment', {
                                initialValue: this.props.store.timeIntervalsAlignment
                            })(
                                <Radio.Group>
                                    <Radio.Button value="none">None</Radio.Button>
                                    <Radio.Button value="sameStartDay">Same start day</Radio.Button>
                                    <Radio.Button value="sameStartYear">Same start year</Radio.Button>
                                </Radio.Group>
                            )}
                        </Form.Item>

                    </Col>
                </Row>
            }

            { this.props.store.outputFormat === 'download' &&
                <Row gutter={8}>
                    <Col span={4}>
                        <span className={s.label}>Download format</span>
                    </Col>
                    <Col span={20}>

                        <Form.Item>
                            {this.props.form.getFieldDecorator('downloadFormat', {
                                initialValue: this.props.store.downloadFormat
                            })(
                                <Select
                                    style={{ width: '200px' }}
                                    dropdownMatchSelectWidth={false}
                                    dropdownStyle={{width: '350px'}}
                                >
                                    <Select.Option value="csv">CSV</Select.Option>
                                    <Select.Option value="csvTimeOriented">CSV for long time series</Select.Option>
                                    <Select.Option value="csvIrregular">CSV for irregular time intervals</Select.Option>
                                    <Select.Option value="xlsx">XSLX Excel</Select.Option>
                                    <Select.Option value="xlsxTimeOriented">XLSX Excel for long time series</Select.Option>
                                    <Select.Option value="xlsxIrregular">XLSX Excel for irregular time intervals</Select.Option>
                                    {/* { this.getEnvironment() !== 'production' &&
                                        <Menu.Item key="xlsxTimeOriented">XLSX Excel for long time series (in development)</Menu.Item>
                                    } */}
                                    <Select.Option value="json">JSON</Select.Option>
                                    <Select.Option value="kml">KML</Select.Option>
                                    <Select.Option value="netCDF">NetCDF</Select.Option>
                                </Select>
                            )}
                        </Form.Item>

                    </Col>
                </Row>
            }

            <Row>
                <Col>

                    <Button
                        id={"executeButton"}
                        type={'primary'}
                        disabled={this.isButtonDisabled()}
                        onClick={() => {
                            const format = this.props.store.outputFormat === 'download'
                                ? this.props.store.downloadFormat
                                : this.props.store.outputFormat
                            this.submitHandler(format)
                        }}
                    >
                        Execute
                        {this.isButtonDisabled() && <Icon type="loading" />}
                    </Button>

                    { this.isDataSeriesVisible() && this.state.dataPoints &&
                        <div className={s.dataPointsMetric}>
                            Data points: {this.state.dataPoints}
                        </div>
                    }

                    <Button
                        style={{float: 'right'}}
                        onClick={() => {
                            this.setState({
                                isContentAreaOpen: false,
                                lastError: false,
                                highcharts: undefined,
                                resultGeoMap: undefined,
                            })
                        }}
                    >
                        Close chart/map
                    </Button>

                    <Button
                        style={{float: 'right', marginRight: '1em'}}
                        onClick={() => {
                            this.setState({
                                isContentAreaOpen: true,
                                lastError: false,
                                highcharts: undefined,
                                resultGeoMap: undefined,
                                metQLQuery: undefined,
                                metQLUrl: undefined
                            })
                            this.props.setDataQuery({
                                shareString: true
                            })
                        }}
                    >
                        Reuse query
                    </Button>

                </Col>
            </Row>

            {this.state.isContentAreaOpen &&

                <Row gutter={8} className={s.contentWrapper}>

                    <div
                        className={s.errorWrapper}
                        style={{display: this.state.lastError ? 'flex' : 'none'}}>
                        <div className={s.apiError + ' ' + (this.state.lastError && s.active)}>
                            <Icon type="exclamation-circle-o" className={s.icon}/>
                            <span>{this.state.lastError}</span>
                        </div>
                    </div>

                    {this.state.isLoading &&
                        <div className={s.loading}>
                            <Spin className={s.loadingIcon} size="large"/>
                            Loading data...

                            {this.state.queueProgress &&
                                <span>&nbsp;this will take a while</span>
                            }

                        </div>
                    }

                    {(this.state.highcharts && !this.state.isLoading) &&
                        <div id={'highchartsContainer'} className={s.highchartsContainer}>
                            <ReactHighcharts
                                config={this.state.highcharts}
                                isPureConfig={true}
                            />
                      </div>
                    }

                    {(this.state.resultGeoMap && !this.state.isLoading) &&
                        <div className={s.highchartsContainer}>
                            {/* TODO: set bounds to layer group */}
                            {/* Warning: Min and max map zoom must be set. Otherwise map will crash on component
                                unmount. No idea why. */}
                            <L.Map style={{height: '600px'}} ref={map => { this.resultMap = map }}
                                center={[47,7]}
                                preferCanvas={true}
                                zoom={7}
                                minZoom={3}
                                maxZoom={15}
                            >
                                { this.tileLayers.map(layer => <L.TileLayer {...layer} />) }
                                <L.FeatureGroup ref={group => { this.resultGroup = group }}>
                                    { this.state.resultGeoMap.features
                                    .map((feature, i) =>
                                        <L.CircleMarker
                                            key={i}
                                            center={[feature.geometry.coordinates[1], feature.geometry.coordinates[0]]}
                                            color="black"
                                            weight={1}
                                            fill={true}
                                            fillColor={feature.properties.color}
                                            fillOpacity={1}
                                            radius={6}
                                        >
                                            <L.Tooltip sticky>
                                                <span>{feature.properties.value}</span>
                                            </L.Tooltip>
                                        </L.CircleMarker>
                                    )}
                                </L.FeatureGroup>
                            </L.Map>
                            <div className={s.warning}>
                                This map shows only the data of the first time step.
                            </div>
                        </div>
                    }

                    {/* MetQL Query */}
                    {this.state.metQLQuery !== undefined &&
                        <Col span={24}>

                            <div className={s.metQLUrlWrapper}>
                                <div className={s.queryHeading}>Encoded URL</div>
                                {/* Show download link only if length < 2000 (GET limit) */}
                                { this.state.metQLUrl.length > 2000 &&
                                    <div className={s.error}>
                                        The URL exceeds 2000 characters length and will not work in some browsers.
                                        Use HTTP POST instead.
                                    </div>
                                }
                                <div className={s.metQLUrl}>
                                    <a id="metQLUrl" /* for cypress */ target="_blank" href={this.state.metQLUrl}>
                                        { this.state.metQLUrl }
                                    </a>
                                </div>
                            </div>

                            <div className={s.metQLUrl}>
                                <div className={s.queryHeading}>cURL</div>
                                <Input.TextArea
                                    id="metQlQueryField"
                                    value={`curl -L -H "Content-Type: application/json" -d '${this.makeMetQL({})}' "http://my.meteoblue.com/dataset/query?apikey=APIKEY"`}
                                    readOnly
                                    autosize={{ minRows: 2, maxRows: 5 }}
                                />
                            </div>

                            <div className={s.metQLJson}>
                                <div className={s.queryHeading}>POST body</div>
                                <Input.TextArea
                                    id="metQlQueryField"
                                    value={this.state.metQLQuery}
                                    readOnly
                                    autosize={{ minRows: 2, maxRows: 30 }}
                                />
                            </div>

                            {/* @todo: hint for signed urls */}
                        </Col>
                    }

                {this.props.store.shareString !== undefined &&
                    <Col span={24}>
                        <div className={s.metQLJson}>
                            Use this string to save and restore form input.<br />
                            {this.props.form.getFieldDecorator('shareString')(
                                <Input.TextArea autosize={{ minRows: 2, maxRows: 4 }} />
                            )}
                        </div>

                        <Button
                            style={{ marginTop: '1em' }}
                            onClick={this.generateShareString}
                        >Generate share string</Button>

                        <Button
                            style={{ marginTop: '1em', marginLeft: '1em' }}
                            disabled={this.props.store.shareString ? false : true}
                            onClick={this.restoreFromShareString}
                        >Restore from share string</Button>
                    </Col>
                }

                </Row>

            }

            <Modal
                title="Queued job"
                visible={this.state.queueModal === 'prompt'}
                okText={"Start"}
                onOk={() => {
                    if(['geoJson', 'highcharts'].includes(this.state.downloadFormat)) {
                        this.submitHandler(this.state.downloadFormat)
                        this.setState({queueModal: 'closed'})
                    } else {
                        this.setState({queueModal: 'running'})
                        this.queuedDownloadHandler()
                    }
                }}
                onCancel={() => {
                    this.setState({queueModal: 'closed'})
                }}
            >
                <p>This job must be queued. Completing this job can take a while.</p>
            </Modal>

            <Modal
                title={`Queued job ${this.state.queueModal}`}
                visible={this.state.queueModal === 'waiting' || this.state.queueModal === 'running'}
                closable={false}
                footer={
                    <Button
                        onClick={() => { this.deleteQueuedJob(this.state.jobId) }}
                    >Delete job</Button>
                }
            >
                <Icon type="loading" style={{ fontSize: 24, marginRight: '0.6em' }} spin />
                { this.state.queueModal === 'waiting' &&
                    <span>Job is queued for execution.</span>
                }
                { this.state.queueModal === 'running' &&
                    <span>Fetching and calculating data. This can take a while.</span>
                }
            </Modal>

            <Modal
                title={`Queued job ${this.state.queueModal}`}
                visible={this.state.queueModal === 'deleted' || this.state.queueModal === 'delete failed'}
                closable={false}
                footer={
                    <Button
                        onClick={() => this.setState({queueModal: 'closed'}) }
                    >Close</Button>
                }
            >
                { this.state.queueModal === 'deleted' &&
                    <span>Job has been deleted.</span>
                }
                { this.state.queueModal === 'delete failed' &&
                    <span>
                        <p>Deleting job has failed.</p>
                        <p>{this.state.queueModalErrorMsg}</p>
                    </span>
                }
            </Modal>

            <Modal
                title="Download result"
                visible={this.state.queueModal === 'done'}
                okText={"Download"}
                onOk={ () => {window.open(this.state.queueDownloadResultUrl)} }
                cancelText={"Close"}
                onCancel={() => {this.setState({queueModal: 'closed'})}}
            >
                <p>Ready. The result is now available under this address for the next 7 days:</p>
                <p>
                    <a href={this.state.queueDownloadResultUrl}>
                        { this.state.queueDownloadResultUrl }
                    </a>
                </p>
            </Modal>

            {/* TODO: implement */}
            <Modal
                title="Queued job failed"
                visible={this.state.queueModal === 'failed'}
                footer={<Button type={'primary'}
                    onClick={() => {this.setState({queueModal: 'closed'})}}
                    >Close</Button>
                }
            >
                <p>{this.state.queueModalErrorMsg}</p>
                <p>If this error is unexpected, please report to meteoblue.</p>
            </Modal>

            <Modal
                title="Download"
                visible={!!this.state.downloadUrl || !!this.state.checkApiError}
                closable={true}
                maskClosable={true}
                onCancel={() => {this.setState({
                    downloadUrl: undefined,
                    checkApiError: undefined
                })}}
                footer={[
                    <Button
                        key="close"
                        onClick={() => {this.setState({
                            downloadUrl: undefined,
                            checkApiError: undefined
                        })}}>
                        Close
                    </Button>
                ]}
            >
                { this.state.downloadUrl &&
                    <React.Fragment>
                        <p>Download URL:</p>
                        <a
                            target="_blank"
                            href={this.state.downloadUrl}
                            style={{wordBreak: 'break-all'}}
                        >{this.state.downloadUrl}</a>
                    </React.Fragment>
                }
                { this.state.checkApiError &&
                    <p>Could not start download: {this.state.checkApiError}</p>
                }
            </Modal>

        </Form>

    )}
}

const mapStateToProps = state => {
    return {
        store: state.dataQuery,
    }
};

const mapDispatchToProps = dispatch => {
    return {
        setDataQuery: (dataQuery) => dispatch({
            type: AvailableActions.SET_DATA_QUERY,
            payload: dataQuery
        })
    }
};

export default connect(mapStateToProps,mapDispatchToProps)(Form.create({
    onValuesChange: (props, values) => {
        values.allDataSeriesValues = values.allDataSeries
        delete values.allDataSeries
        delete values.dateRanges
        props.setDataQuery(values);
        props.setDataQuery({ metQLJson: undefined })
}})(DataQueryForm));